module.exports = __webpack_public_path__ + "24h.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/24h.png
// module id = 631
// module chunks = 0